import type { TouchEvent } from 'react'
import { useEffect, useRef } from 'react'

const SWIPE_THRESHOLD_PX = 50

export const useLightboxInput = ({
  onPrev,
  onNext,
  onClose,
}: {
  onPrev: () => void
  onNext: () => void
  onClose: () => void
}) => {
  const touchStartX = useRef<number | null>(null)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') onPrev()
      if (e.key === 'ArrowRight') onNext()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onClose, onNext, onPrev])

  const onTouchStart = (e: TouchEvent) => {
    touchStartX.current = e.touches[0]?.clientX ?? null
  }

  const onTouchEnd = (e: TouchEvent) => {
    if (touchStartX.current === null) return
    const delta = (e.changedTouches[0]?.clientX ?? 0) - touchStartX.current
    if (Math.abs(delta) >= SWIPE_THRESHOLD_PX) {
      if (delta < 0) {
        onNext()
      } else {
        onPrev()
      }
    }
    touchStartX.current = null
  }

  return { onTouchStart, onTouchEnd }
}
